<section class="static-text">
  <div class="static-text--container">
    <div class="static-text--content">
      <!-- Left Column: Mission Statement Box -->
      <div class="static-text--mission-box">
        <img [src]="conceptCardImage" alt="Mission statement" class="mission--card-image" />
      </div>

      <!-- Right Column: Description Text -->
      <div class="static-text--description">
        <p class="description--text">
          MahaAgX is a strategic initiative by the Department of Agriculture, Govt. of Maharashtra, designed to catalyze secure data exchange and agricultural innovation. By providing a robust ecosystem of rich agricultural data banks, open-source AI models, and a high-performance Innovation Sandbox featuring GPU-based compute and integrated development tools, MahaAgX empowers the creation of scalable AI Use Cases. Our mission is to transform raw data into real-world solutions that address the critical challenges of our farmers. This platform stands as a testament to Maharashtra's commitment to digital leadership, climate-resilient farming, and technology-driven agricultural governance.
 </p>
      </div>
    </div>
  </div>
</section>



